const onboardingEmailTemplate = (data) => `
Shop Manager Name: ${data.shopManagerName}
Phone: ${data.phone}
Email: ${data.email}
Schedule Onsite Evaluation: ${data.scheduleOnsiteEval}
Evaluation Date: ${data.date}
Create eCommerce Account: ${data.createEcommerceAccount === 'on' ? 'Yes' : 'No'}
Agreed to Terms: ${data.agreeTermsCheckBox === 'on' ? 'Yes' : 'No'}
Opt-In: ${data.optin === 'on' ? 'Yes' : 'No'}
`;

export default onboardingEmailTemplate;
